<template>
  <div class="tp-widget">
    <div class="d-flex justify-content-between align-items-start gap-2 mb-2">
      <div>
        <div class="tp-widget-kicker">Próximos entrenos</div>
        <p v-if="subtitulo" class="text-muted small mb-0">{{ subtitulo }}</p>
      </div>
      <slot name="accion"></slot>
    </div>

    <p v-if="!configured" class="text-muted small mb-0">
      Conecta TrainingPeaks en <router-link to="/perfil">Perfil</router-link> para ver el plan del entrenador.
    </p>
    <p v-else-if="!lista.length" class="text-muted small mb-0">
      No hay entrenos planificados en los próximos días.
    </p>
    <ul v-else class="tp-widget-list list-unstyled mb-0">
      <li
        v-for="entreno in lista"
        :key="entreno.id || (entreno.date + entreno.title)"
        class="tp-widget-item"
        :class="{ 'tp-widget-item--hoy': esHoy(entreno) }"
      >
        <div class="tp-widget-day">
          <span v-if="esHoy(entreno)" class="badge bg-primary me-1">Hoy</span>
          <template v-else>{{ entreno.etiqueta }}</template>
          <span v-if="entreno.sport">
            <template v-if="!esHoy(entreno)"> · </template>
            {{ entreno.sport }}
          </span>
        </div>
        <div class="tp-widget-title">
          {{ entreno.title }}
          <span v-if="entreno.completed" class="badge bg-success ms-1 tp-widget-done">Hecho</span>
        </div>
        <div v-if="lineaMeta(entreno)" class="tp-widget-meta">{{ lineaMeta(entreno) }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { lineaMeta } from '../utils/trainingpeaksProximos';

export default {
  name: 'TpProximosWidget',
  props: {
    configured: { type: Boolean, default: false },
    entrenos: { type: Array, default: () => [] },
    subtitulo: { type: String, default: '' },
    limite: { type: Number, default: 5 },
  },
  computed: {
    lista() {
      return (this.entrenos || []).slice(0, this.limite);
    },
  },
  methods: {
    lineaMeta,
    esHoy(entreno) {
      return Boolean(entreno && (entreno.etiqueta === 'Hoy'));
    },
  },
};
</script>

<style scoped>
.tp-widget-kicker {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6f42c1;
}
.tp-widget-list {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}
.tp-widget-item {
  padding-bottom: 0.65rem;
  border-bottom: 1px solid #eef0f3;
}
.tp-widget-item:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}
.tp-widget-item--hoy {
  background: rgba(13, 110, 253, 0.06);
  margin: 0 -0.5rem;
  padding: 0.5rem 0.5rem 0.65rem;
  border-radius: 0.5rem;
  border-bottom-color: transparent;
}
.tp-widget-day {
  font-size: 0.72rem;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6c757d;
}
.tp-widget-title {
  font-weight: 650;
  line-height: 1.25;
}
.tp-widget-done {
  font-size: 0.65rem;
  vertical-align: middle;
}
.tp-widget-meta {
  font-variant-numeric: tabular-nums;
  font-size: 0.86rem;
  color: #495057;
}
</style>
